import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { editSupplyBillItem } from '../../../../../store/supplyBillSlice'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MyButton from '../../../../UI/form/MyButton'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ExpenseTypeSelectMain from '../../../../form/fields/ExpenseTypeSelectMain'
import { editSupplyBillItemExpenseTypeAPI } from '../../../../../api/supply/supplyBillItemAPI'

const ChangeExpenseTypeForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyBillItemBd ? 
            {
                expenseTypeId: supplyBillItemBd.expenseTypeId,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyBillItemExpenseTypeAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyBillItemBd.id,
            expenseTypeId: data.expenseTypeId,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('expenseTypeId', 'supplyBillItem') ?
				<ExpenseTypeSelectMain
					required={formDataProductRequiredField('expenseTypeId', 'supplyBillItem')}
					setValidate={e => updateValidate(setValid, 'expenseTypeId', e)}
					setValueForm={e => setValueForm(setData, 'expenseTypeId', e)}
					forciblyValue={data && data.expenseTypeId ? data.expenseTypeId : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeExpenseTypeForm